import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../src/taskpane/components/_v2/redux/storeMain";
import { setContentManagerFilterSectionsReset, setContentManagerSearchFilterType } from "../../../src/taskpane/redux/modules/contentManagerDirectory";
import { LanguageContext } from "../../../utilities/LocalizationModule";
import { toggleReload } from "../../../src/taskpane/redux/modules/reload";
import { menuItemIconStyles } from "../../../src/taskpane/config/controlStyles";
import { FilterDismiss20Regular } from "../../../src/taskpane/components/_v2/components/SvgIcons/FilterDismiss20Regular";

export function useMenuItem_ClearFilter(waitFor: boolean) {
  const languageStrings = React.useContext(LanguageContext);
  const dispatch = useDispatch();

  const filterSections = useSelector((state: RootState) => state.contentManagerDirectory?.filterSections);
  const searchValue = useSelector((state: RootState) => state.contentManagerDirectory?.searchValue);

  const onClearFilter = React.useCallback(() => {
    dispatch(setContentManagerFilterSectionsReset());
    dispatch(setContentManagerSearchFilterType(""));
    dispatch(toggleReload());
  }, [dispatch]);

  const menuItem_ClearFilter = React.useMemo(() => {

    const isMetadataOrDateFilterActive = filterSections?.some(section =>
      section.items?.some(item => item.selected === true) ||
      section.daysOffset ||
      section.daysOffset === 0
    );

    const isSearchFilterTypeActive = searchValue && !searchValue.value && searchValue.filterType !== "";

    const isFilterSelected = isMetadataOrDateFilterActive || isSearchFilterTypeActive;

    if (isFilterSelected) {
      return {
        key: "clearFilter",
        text: languageStrings.ClearFilter,
        disabled: waitFor === true,
        // iconProps: { iconName: "ClearFilter" },
        iconProps: {},
        onRenderIcon: () => <FilterDismiss20Regular className={menuItemIconStyles} />,
        onClick: onClearFilter,
      } as IContextualMenuItem;
    }

    return null;

  }, [
    filterSections,
    searchValue,
    waitFor,
    languageStrings,
    onClearFilter
  ]);

  return {
    menuItem_ClearFilter
  };
}